import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
// import Nosotros from '../views/Nosotros.vue'
// import Servicios from '../views/Servicios.vue'
// import Cornea from '../views/Cornea.vue'
// import NuestrosEspecialistas from '../views/NuestrosEspecialistas.vue'
// import CirugiaLasik from '../views/CirugiaLasik.vue'
// import Glaucoma from '../views/Glaucoma.vue'
// import Retina from '../views/Retina.vue'
// import Uveitis from '../views/Uveitis.vue'
// import Neuroftalmologia from '../views/Neuroftalmologia.vue'
// import CirugiaParpados from '../views/CirugiaParpados.vue'
// import OftalmologiaPediatrica from '../views/OftalmologiaPediatrica.vue'
// import AjusteLimpiezaArmazones from '../views/AjusteLimpiezaArmazones.vue'
// import LentesContacto from '../views/LentesContacto.vue'
// import Catarata from '../views/Catarata.vue'
// import Contacto from '../views/Contacto.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'home',
  component: () => import('../views/Home.vue')
},
{
  path: '/nosotros',
  name: 'nosotros',
  component: () => import('../views/Nosotros.vue')
},
{
  path: '/servicios',
  name: 'servicios',
  component: () => import('../views/Servicios.vue')
},
{
  path: '/servicios/cornea',
  name: 'cornea',
  component: () => import('../views/servicios/Cornea.vue')
},
{
  path: '/servicios/cirugia-lasik',
  name: 'CirugiaLasik',
  component: () => import('../views/servicios/CirugiaLasik.vue')
},
{
  path: '/servicios/glaucoma',
  name: 'Glaucoma',
  component: () => import('../views/servicios/Glaucoma.vue')
},
{
  path: '/servicios/catarata',
  name: 'Catarata',
  component: () => import('../views/servicios/Catarata.vue')
},
{
  path: '/servicios/retina',
  name: 'Retina',
  component: () => import('../views/servicios/Retina.vue')
},
{
  path: '/servicios/uveitis',
  name: 'Uveitis',
  component: () => import('../views/servicios/Uveitis.vue')
},
{
  path: '/servicios/neuroftalmologia',
  name: 'Neuroftalmologia',
  component: () => import('../views/servicios/Neuroftalmologia.vue')
},
{
  path: '/servicios/cirugia-de-parpados',
  name: 'CirugiaParpados',
  component: () => import('../views/servicios/CirugiaParpados.vue')
},
{
  path: '/servicios/oftalmologia-pediatrica',
  name: 'OftalmologiaPediatrica',
  component: () => import('../views/servicios/OftalmologiaPediatrica.vue')
},
{
  path: '/servicios/lentes-de-contacto',
  name: 'LentesContacto',
  component: () => import('../views/servicios/LentesContacto.vue')
},
{
  path: '/servicios/ajuste-y-limpieza-de-armazones',
  name: 'AjusteLimpiezaArmazones',
  component: () => import('../views/servicios/AjusteLimpiezaArmazones.vue')
},
{
  path: '/nuestros-especialistas',
  name: 'nuestros-especialistas',
  component: () => import('../views/NuestrosEspecialistas.vue')
},
{
  path: '/contacto',
  name: 'contacto',
  component: () => import('../views/Contacto.vue')
},
{
  path: '/nuestros-especialistas/Dr-Juan-Cordero',
  name: 'Dr-Juan-Cordero',
  component: () => import('../views/doctores/DoctorJuanCordero.vue')
},
{
  path: '/nuestros-especialistas/Dr-Juan-Sánchez',
  name: 'Dr-Juan-Sanchez',
  component: () => import('../views/doctores/DoctorJuanSanchez.vue')
},
{
  path: '/nuestros-especialistas/Dra-Edith-Martínez',
  name: 'Dra-EdithMartinez',
  component: () => import('../views/doctores/DoctoraEdithMartinez.vue')
},
// sdjsnf
{
  path: '/nuestros-especialistas/Dra-Mónica-Ayala',
  name: 'Dra-MonicaAyala',
  component: () => import('../views/doctores/DoctoraMonicaAyala.vue')
},
{
  path: '/nuestros-especialistas/Dr-Fernando-Magdaleno',
  name: 'Dr-FernandoMagdaleno',
  component: () => import('../views/doctores/DoctorFernandoMagdaleno.vue')
},
{
  path: '/nuestros-especialistas/Dra-Carla-Gutiérrez',
  name: 'Dra-CarlaGutierrez',
  component: () => import('../views/doctores/DoctoraCarlaGutierrez.vue')
},
{
  path: '/nuestros-especialistas/Dra-Claudia-Arellanos',
  name: 'Dra-ClaudiaArellanos',
  component: () => import('../views/doctores/DoctoraClaudiaArellanos.vue')
},
{
  path: '/nuestros-especialistas/Dr-Mauricio-López',
  name: 'Dr-MauricioLopez',
  component: () => import('../views/doctores/DoctorMauricioLopez.vue')
},
{
  path: '/nuestros-especialistas/Dra-Verónica-Torres',
  name: 'Dra-VeronicaTorres',
  component: () => import('../views/doctores/DoctoraVeronicaTorres.vue')
},
{
  path: '/nuestros-especialistas/Dra-Adriana-Gallegos',
  name: 'Dra-AdrianaGallegos',
  component: () => import('../views/doctores/DoctoraAdrianaGallegos.vue')
},
{
  path: '/nuestros-especialistas/Dra-Leticia-Márquez',
  name: 'Dra-LeticiaMarquez',
  component: () => import('../views/doctores/DoctoraLeticiaMarquez.vue')
},
{
  path: '/nuestros-especialistas/Dr-Pedro-Briano',
  name: 'Dr-PedroBriano',
  component: () => import('../views/doctores/DoctorPedroBriano.vue')
},
{
  path: '/nuestros-especialistas/Dr-José-Antonio-Uribe',
  name: 'Dr-JoseAntonioUribe',
  component: () => import('../views/doctores/DoctorJoseAntonioUribe.vue')
},
{
  path: '/nuestros-especialistas/Dra-Berenice-Cámara',
  name: 'Dra-BereniceCámara',
  component: () => import('../views/doctores/DoctoraBereniceCamara.vue')
},
{
  path: '/nuestros-especialistas/Dra-Romelia-Lechuga',
  name: 'Dra-RomeliaLechuga',
  component: () => import('../views/doctores/DoctoraRomeliaLechuga.vue')
},
{
  path: '/nuestros-especialistas/Dra-Jessica-Zermeño',
  name: 'Dra-JessicaZermeno',
  component: () => import('../views/doctores/DoctoraJessicaZermeno.vue')
},
{
  path: '/nuestros-especialistas/Dr-Sergio-López',
  name: 'Dr-SergioLopez',
  component: () => import('../views/doctores/DoctorSergioLopez.vue')
},
{
  path: '/nuestros-especialistas/Dra-Carmen-Soria',
  name: 'Dra-CarmenSoria',
  component: () => import('../views/doctores/DoctoraCarmenSoria.vue')
},
{
  path: '/nuestros-especialistas/Dra-Carolina-Gutiérrez',
  name: 'Dra-CarolinaGutierrez',
  component: () => import('../views/doctores/DoctoraCarolinaGutierrez.vue')
},
{
  path: '/pago-en-linea',
  name: 'pagoEnLinea',
  component: () => import('@/views/PagoEnLinea.vue')
},
{
  path: '/about',
  name: 'about',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: function () {
    return import( /* webpackChunkName: "about" */ '../views/About.vue')
  }
}
]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

export default router